export default {
  noRecentForecasts: "No recent forecasts for this site.",
  title: "Activity"
};
